// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../common/fonts/NunitoSans-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-field {
  padding: 0;
}

.form-control {
  height: 47px;
  border: 1px solid #77889e;
  border-radius: 8px;
  padding: 6px 12px;
  color: #3f3f3f;
  font-size: 18px;
}
.form-control:focus {
  outline-offset: 3px;
  outline: 2px solid #0d2b38;
  box-shadow: none;
  border: 1px solid #77889e;
}
.form-control::placeholder {
  color: #0d2b38;
  font-size: 16px;
}

.btn:focus,
a:focus,
input[type=checkbox]:focus,
input[type=radio]:focus {
  box-shadow: none;
  outline-offset: 3px;
  outline: 2px solid #0d2b38;
}

label {
  font-size: 16px;
  padding: 0 10px;
  color: #3f3f3f;
}

.skip-button,
.pharmacy-button,
.back-to-pharmacy,
.go-to-Shopping,
.nocoupon-button {
  padding: 12px 24px;
  color: #3f3f3f;
  border: 1px solid #7a879c;
  border-radius: 90px;
  background-color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
}
.skip-button:disabled, .skip-button:hover, .skip-button:active,
.pharmacy-button:disabled,
.pharmacy-button:hover,
.pharmacy-button:active,
.back-to-pharmacy:disabled,
.back-to-pharmacy:hover,
.back-to-pharmacy:active,
.go-to-Shopping:disabled,
.go-to-Shopping:hover,
.go-to-Shopping:active,
.nocoupon-button:disabled,
.nocoupon-button:hover,
.nocoupon-button:active {
  background-color: #e8f2fa;
  border: 1px solid #002f6c;
  color: #002f6c;
}

.pharmacy-secondary-button {
  padding: 12px 24px;
  color: #0d2b38;
  border: 1px solid #7a879c;
  border-radius: 90px;
  background-color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
}
.pharmacy-secondary-button:disabled, .pharmacy-secondary-button:hover, .pharmacy-secondary-button:active {
  background-color: #e8f2fa;
  border: 1px solid #002f6c;
  color: #002f6c;
}

.no-offer-btn,
.continue-button,
.Submit-button,
.Close-button,
.next-button,
.go-to-grocery,
.account-button,
.claim-offer-btn,
.btn-close {
  background-color: #0d2b38;
  border: none;
  padding: 12px 24px;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  text-decoration: none;
}
.no-offer-btn:disabled,
.continue-button:disabled,
.Submit-button:disabled,
.Close-button:disabled,
.next-button:disabled,
.go-to-grocery:disabled,
.account-button:disabled,
.claim-offer-btn:disabled,
.btn-close:disabled {
  background-color: #eee8e5;
  color: #7a879c;
}
.no-offer-btn:focus, .no-offer-btn:hover, .no-offer-btn:active,
.continue-button:focus,
.continue-button:hover,
.continue-button:active,
.Submit-button:focus,
.Submit-button:hover,
.Submit-button:active,
.Close-button:focus,
.Close-button:hover,
.Close-button:active,
.next-button:focus,
.next-button:hover,
.next-button:active,
.go-to-grocery:focus,
.go-to-grocery:hover,
.go-to-grocery:active,
.account-button:focus,
.account-button:hover,
.account-button:active,
.claim-offer-btn:focus,
.claim-offer-btn:hover,
.claim-offer-btn:active,
.btn-close:focus,
.btn-close:hover,
.btn-close:active {
  background-color: #0d2b38;
  color: #fff;
  outline-offset: 3px;
  outline: 2px solid #0d2b38;
  box-shadow: none;
}

.btn-close:hover {
  opacity: 1;
}

.has-error {
  border: 1px solid #ff5e48 !important;
}
.has-error .form-control:focus {
  box-shadow: 0 0 0 0 #ff5e48 !important;
}

.hero-text {
  color: #0d2b38;
  font-size: 28px;
  font-weight: 500;
}

.correct-icon {
  background-color: #43741d;
  padding: 3px 5px;
  border-radius: 15px;
  top: 0;
  right: 0;
  position: absolute;
  margin: 10px;
}

@font-face {
  font-family: "NunitoSans-ExtraBold";
  src: local("NunitoSans-ExtraBold"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
.extra-bold {
  font-family: "NunitoSans-ExtraBold", Arial, Helvetica, sans-serif;
}

.termsLimitationsText {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #4d4d4f;
  padding: 10px 0;
}

.exclamation-div {
  display: flex;
  margin-right: 50px;
  padding-top: 5px;
}
.exclamation-div figure {
  margin-right: 5px;
}

.date-error {
  color: #a20f15;
  font-size: 14px;
}

.error-label {
  color: #a20f15;
}

@media only screen and (min-width: 576px) {
  .col-sm-3 {
    text-align: right;
  }
}
.paragraph {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #4d4d4f;
}

.subscribe-para-text {
  font-size: 16px;
  text-align: left;
  font-weight: 600;
}
.subscribe-para-text strong {
  font-size: 18px;
}

.email-text {
  font-size: 15px;
  color: #000000;
  text-align: center;
}

.logo-header-wrapper {
  background-color: #ffffff;
  height: 54px;
  padding: 16px;
}
.logo-header-wrapper .unsubscribe-logo {
  height: 22px;
}
.logo-header-wrapper .unsubscribe-logo img {
  height: 22px;
}

.display-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.unsubscribe-wrapper {
  padding: 30px 20px 30px;
  opacity: 1;
  top: 30px;
  position: relative;
  border-radius: 20px;
  box-shadow: 0px 0px 10px rgba(3, 38, 68, 0.1);
  background-color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/common/common.scss","webpack://./src/components/UnSubscribeForm/Unsubscribe.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;ACCF;;ADCA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;ACEF;ADDE;EACE,mBAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;ACGJ;ADDE;EACE,cAAA;EACA,eAAA;ACGJ;;ADAA;;;;EAIE,gBAAA;EACA,mBAAA;EACA,0BAAA;ACGF;;ADDA;EACE,eAAA;EACA,eAAA;EACA,cAAA;ACIF;;ADFA;;;;;EAKE,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;ACKF;ADJE;;;;;;;;;;;;;EAGE,yBAAA;EACA,yBAAA;EACA,cAAA;ACgBJ;;ADZA;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;ACeF;ADdE;EAGE,yBAAA;EACA,yBAAA;EACA,cAAA;ACcJ;;ADVA;;;;;;;;;EASE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;ACaF;ADZE;;;;;;;;;EACE,yBAAA;EACA,cAAA;ACsBJ;ADpBE;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;AC4CJ;;ADvCE;EACE,UAAA;AC0CJ;;ADvCA;EACE,oCAAA;AC0CF;ADzCE;EACE,sCAAA;AC2CJ;;ADvCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC0CF;;ADxCA;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,MAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;AC2CF;;ADxCA;EACE,mCAAA;EACA,8FAAA;AC2CF;ADvCA;EACE,iEAAA;ACyCF;;ADtCA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;ACyCF;;ADtCA;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;ACyCF;ADxCE;EACE,iBAAA;AC0CJ;;ADvCA;EACE,cAAA;EACA,eAAA;AC0CF;;ADxCA;EACE,cAAA;AC2CF;;ADxCA;EACE;IACE,iBAAA;EC2CF;AACF;ADxCA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AC0CF;;AA9NA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAiOF;AAhOE;EACE,eAAA;AAkOJ;;AA/NA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAkOF;;AAhOA;EACE,yBAAA;EACA,YAAA;EACA,aAAA;AAmOF;AAlOE;EACE,YAAA;AAoOJ;AAnOI;EACE,YAAA;AAqON;;AAhOA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAmOF;;AAjOA;EACE,uBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,6CAAA;EACA,yBAAA;AAoOF","sourcesContent":[".input-field {\n  padding: 0;\n}\n.form-control {\n  height: 47px;\n  border: 1px solid #77889e;\n  border-radius: 8px;\n  padding: 6px 12px;\n  color: #3f3f3f;\n  font-size: 18px;\n  &:focus {\n    outline-offset: 3px;\n    outline: 2px solid #0d2b38;\n    box-shadow: none;\n    border: 1px solid #77889e;\n  }\n  &::placeholder {\n    color: #0d2b38;\n    font-size: 16px;\n  }\n}\n.btn:focus,\na:focus,\ninput[type='checkbox']:focus,\ninput[type='radio']:focus {\n  box-shadow: none;\n  outline-offset: 3px;\n  outline: 2px solid #0d2b38;\n}\nlabel {\n  font-size: 16px;\n  padding: 0 10px;\n  color: #3f3f3f;\n}\n.skip-button,\n.pharmacy-button,\n.back-to-pharmacy,\n.go-to-Shopping,\n.nocoupon-button {\n  padding: 12px 24px;\n  color: #3f3f3f;\n  border: 1px solid #7a879c;\n  border-radius: 90px;\n  background-color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n  text-align: center;\n  text-decoration: none;\n  &:disabled,\n  &:hover,\n  &:active {\n    background-color: #e8f2fa;\n    border: 1px solid #002f6c;\n    color: #002f6c;\n  }\n}\n\n.pharmacy-secondary-button {\n  padding: 12px 24px;\n  color: #0d2b38;\n  border: 1px solid #7a879c;\n  border-radius: 90px;\n  background-color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n  text-align: center;\n  text-decoration: none;\n  &:disabled,\n  &:hover,\n  &:active {\n    background-color: #e8f2fa;\n    border: 1px solid #002f6c;\n    color: #002f6c;\n  }\n}\n\n.no-offer-btn,\n.continue-button,\n.Submit-button,\n.Close-button,\n.next-button,\n.go-to-grocery,\n.account-button,\n.claim-offer-btn,\n.btn-close {\n  background-color: #0d2b38;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 40px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n  text-align: center;\n  text-decoration: none;\n  &:disabled {\n    background-color: #eee8e5;\n    color: #7a879c;\n  }\n  &:focus,\n  &:hover,\n  &:active {\n    background-color: #0d2b38;\n    color: #fff;\n    outline-offset: 3px;\n    outline: 2px solid #0d2b38;\n    box-shadow: none;\n  }\n}\n\n.btn-close {\n  &:hover {\n    opacity: 1;\n  }\n}\n.has-error {\n  border: 1px solid #ff5e48 !important;\n  .form-control:focus {\n    box-shadow: 0 0 0 0 #ff5e48 !important;\n  }\n}\n\n.hero-text {\n  color: #0d2b38;\n  font-size: 28px;\n  font-weight: 500;\n}\n.correct-icon {\n  background-color: #43741d;\n  padding: 3px 5px;\n  border-radius: 15px;\n  top: 0;\n  right: 0;\n  position: absolute;\n  margin: 10px;\n}\n\n@font-face {\n  font-family: 'NunitoSans-ExtraBold';\n  src: local('NunitoSans-ExtraBold'),\n    url('./fonts/NunitoSans-ExtraBold.ttf') format('truetype');\n}\n\n.extra-bold {\n  font-family: 'NunitoSans-ExtraBold', Arial, Helvetica, sans-serif;\n}\n\n.termsLimitationsText {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 22px;\n  color: #4d4d4f;\n  padding: 10px 0;\n}\n\n.exclamation-div {\n  display: flex;\n  margin-right: 50px;\n  padding-top: 5px;\n  figure {\n    margin-right: 5px;\n  }\n}\n.date-error {\n  color: #a20f15;\n  font-size: 14px;\n}\n.error-label {\n  color: #a20f15;\n}\n\n@media only screen and (min-width: 576px) {\n  .col-sm-3 {\n    text-align: right;\n  }\n}\n\n.paragraph {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  color: #4d4d4f;\n}\n","@import '../../common/common.scss';\n.subscribe-para-text {\n  font-size: 16px;\n  text-align: left;\n  font-weight: 600;\n  strong {\n    font-size: 18px;\n  }\n}\n.email-text {\n  font-size: 15px;\n  color: #000000;\n  text-align: center;\n}\n.logo-header-wrapper {\n  background-color: #ffffff;\n  height: 54px;\n  padding: 16px;\n  .unsubscribe-logo {\n    height: 22px;\n    img {\n      height: 22px;\n    }\n  }\n}\n\n.display-flex {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.unsubscribe-wrapper {\n  padding: 30px 20px 30px;\n  opacity: 1;\n  top: 30px; \n  position: relative;\n  border-radius: 20px;\n  box-shadow: 0px 0px 10px rgba(3, 38, 68, 0.1);\n  background-color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
